import { i18nKeys } from 'translationTypes'
import i18n from '../../../i18n'

export default {
  title: () => i18n.t(i18nKeys.excitement__download_app__body_title),
  contentHeader: () => i18n.t(i18nKeys.excitement__download_app__body_content),
  bodyList1: () => i18n.t(i18nKeys.excitement__download_app__body__list_1),
  bodyList2: () => i18n.t(i18nKeys.excitement__download_app__body__list_2),
  bodyList3: () => i18n.t(i18nKeys.excitement__download_app__body__list_3),
}
